import React from 'react';

function RestrictedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none">
      <path
        d="M4 13V3H7.92588C8.73014 3 9.4049 3.13346 9.95016 3.40039C10.4988 3.66732 10.9129 4.04167 11.1923 4.52344C11.4752 5.00195 11.6166 5.56022 11.6166 6.19824C11.6166 6.83952 11.4735 7.39616 11.1872 7.86816C10.9044 8.33691 10.4869 8.69987 9.93482 8.95703C9.38275 9.21094 8.70458 9.33789 7.90032 9.33789H5.10415V7.83398H7.64473C8.11502 7.83398 8.50011 7.77214 8.8 7.64844C9.09989 7.52148 9.32141 7.33757 9.46454 7.09668C9.61108 6.85254 9.68435 6.55306 9.68435 6.19824C9.68435 5.84342 9.61108 5.54069 9.46454 5.29004C9.318 5.03613 9.09478 4.84408 8.79489 4.71387C8.49499 4.5804 8.1082 4.51367 7.6345 4.51367H5.89649V13H4ZM9.40831 8.46875L12 13H9.88371L7.33802 8.46875H9.40831Z"
        fill="#B57714"
      />
    </svg>
  );
}

export default RestrictedIcon;
